import { Model } from '@/app/shared/models/model';
import { TenantFileType } from '@/app/shared/enums';

export class IntegrationFileModel extends Model {
  public Type!: TenantFileType;
  public ReadingFileName!: string;
  public ReadingTemplate!: string;
  public WritingFileName!: string;
  public WritingTemplate!: string;
  public Active!: boolean;
}
